import Box from '@mui/material/Box';

export default function Results(props) {
    const { result } = props;
    return (
        <>
            {result &&
                <Box sx={{ px: 2, pb: 1 }}>
                    {result}
                </Box>
            }
        </>
    )
};
